import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface QuickStat {
    id?: string;
    label: string;
    value: string;
    icon: LucideIcon;
    gradient: string;
    iconColor: string;
    bgGradient: string;
}

interface QuickStatsRowProps {
    stats: QuickStat[];
    isDarkMode: boolean;
    onStatClick?: (id: string) => void;
}

export function QuickStatsRow({ stats, isDarkMode, onStatClick }: QuickStatsRowProps) {
    return (
        <div className="grid grid-cols-3 gap-2 mb-6">
            {stats.map((stat, index) => (
                <motion.div
                    key={stat.label}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 + index * 0.1, type: "spring" }}
                    whileHover={{ scale: 1.05, y: -4 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onStatClick && stat.id && onStatClick(stat.id)}
                    className={`
            relative overflow-hidden rounded-2xl cursor-pointer
            ${isDarkMode
                            ? `bg-gradient-to-br ${stat.gradient} p-3.5`
                            : `bg-gradient-to-br ${stat.bgGradient} backdrop-blur p-1 border-2 border-white/60`
                        }
          `}
                >
                    <div className={`
            ${isDarkMode ? '' : 'bg-white/90 backdrop-blur rounded-xl p-3'}
            text-center
          `}>
                        <stat.icon className={`w-5 h-5 mx-auto mb-1.5 ${isDarkMode ? 'text-white' : stat.iconColor
                            }`} strokeWidth={2.5} />
                        <div className={`text-lg mb-0.5 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{stat.value}</div>
                        <div className={`text-[9px] ${isDarkMode ? 'text-white/80' : 'text-gray-600'}`}>{stat.label}</div>
                    </div>
                </motion.div>
            ))}
        </div>
    );
}
